
export const data = {
    web: {
      class: "webdesign",
      title: "Web Design",
      description:
        "We build websites that serve as powerful marketing tools and bring memorable brand experiences",
    },
    app: {
      class: "appdesign",
      title: "App Design",
      description:
        "Our mobile designs bring intuitive digital solutions to your customers right at their fingertips.",
    },
    graphic: {
      class: "graphicdesign",
      title: "Graphic Design",
      description:
        "We deliver eye-catching branding materials taht are tailored to meet your business objectives.",
    },
  };
  
export default data;